import { gameAction } from "_actions";
import React, { useEffect, useRef, useState } from "react";
import { Translation } from "react-i18next";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import ProvidersSwiper from "../LiveCasino/ProvidersSwiper";
import PageBanner from "../PageBanner";
import ProvidersMobileSwiper from "../LiveCasino/ProvidersMobileSwiper";
import FilterTypes from "../LiveCasino/FilterTypes";
import { MdOutlineCasino } from "react-icons/md";
import { PiCoinsBold } from "react-icons/pi";

import PragmaticGameBox from "../GamerBoxes/PragmaticGameBox";
import SmartSoftGameBox from "../GamerBoxes/SmartSoftGameBox";
import BLAS975GameBox from "../GamerBoxes/BLAS975GameBox";
import { useParams } from "react-router-dom";
import WMGameBox from "../GamerBoxes/WMGameBox";
import DetroitBox from "../GamerBoxes/DetroitBox";
import { isBrowser, isMobile, isTablet, isAndroid } from "react-device-detect";
import TimelessTechGameBox from "../GamerBoxes/TimelessTechGameBox";
import LiveGameBox from "../GamerBoxes/LiveGameBox";
import TimelessTechGameBoxLive from "../GamerBoxes/TimelessTechGameBoxLive";
import CategoryType from "./CategoryType";
import BannerCarousel from "../Home/BannerCarousel";
import BottomNavigation from "../BottomNavigation";
import Footer from "../Home/Footer";
import NoGamesFound from "../Games/NoGamesFound";
import MatGameBox from "../GamerBoxes/MatGameBox";
import InnovaBox from "../GamerBoxes/InnovaBox";
import BannerCarouselV2 from "../Home/BannerCarouselV2";
import GaseaBox from "../GamerBoxes/GaseaBox";
import LiveProviderSwipeSelector from "./LiveProviderSwipeSelector";

const ScrollableListView = (props) => {
  const [updatedListKey, setupdatedListKey] = useState(new Date().toJSON());
  const {
    user,
    loggedIn,
    sports,
    games,
    UpdateSport,
    //   data,
    pb,
    provider,
    setProvider,
    FilterSearchValue,
    setFilterSearchValue,
    selectedProviders,
    setSelectedProviders,
    isDirectLobby,
    title,
  } = props;

  const [lastScrollTop, setLastScrollTop] = useState(0);
  const [isNavVisible, setIsNavVisible] = useState(true);

  const [visibleData, setVisibleData] = useState([]);
  const containerRef = useRef(null);
  const [activeFilterButton, setActiveFilterButton] = useState(0); // 0 = hiçbiri, 1 = buton1, 2 = buton2

  const [fabActive, setFabActive] = useState(false);

  const [acitveMenu, setActiveMenu] = useState("hot");
  const [data, setData] = useState([...props.data]);

  let params = GetParams();

  function GetParams() {
    let params = useParams();
    return params;
  }

  const handleScroll = () => {
    const { scrollTop, clientHeight, scrollHeight } = containerRef.current;
    if (scrollTop > 300 && !fabActive) {
      setFabActive(true);
      // debugger;
    }
    if (scrollTop < 300 && fabActive) {
      setFabActive(false);
      //    debugger;
    }

    if (scrollTop + clientHeight >= scrollHeight) {
      setVisibleData((prevData) => [
        ...prevData,
        ...data?.slice(prevData.length, prevData.length + 40),
      ]); // Load next 10 items, adjust as needed
    }

    /*
      if (scrollTop > lastScrollTop) {
        setIsNavVisible(false);
      } else {
        setIsNavVisible(true);
      }
      */
    setLastScrollTop(scrollTop <= 0 ? 0 : scrollTop);
  };
  useEffect(() => {
    const _v = data ? data.slice(0, 40) : [];
    setVisibleData(_v); // Initial rendering, show first 10 items
  }, [data]);

  const adjustHeight = () => {
    try {
      const navbarHeight = document.querySelector(".base-nav")?.offsetHeight;
      const navbarHeight1 = document.querySelector(".base-nav1")?.offsetHeight;
      const windowHeight = window.innerHeight;

      if (containerRef && containerRef.current) {
        const h =
          windowHeight -
          (navbarHeight > navbarHeight1 ? navbarHeight : navbarHeight1);
        containerRef.current.style.height = `${h}px`;
      }
    } catch (error) { }
  };

  useEffect(() => {
    window.addEventListener("DOMContentLoaded", adjustHeight);
    window.addEventListener("resize", adjustHeight);
    const _group = props.data.reduce((a, v) => ((a[v._middleware === "innova" ? `${v.vendor}_innova` : v.vendor] ??= []).push(v), a), {})
    const _ex = Object.keys(_group).map(x => {
      return ({
        "AllowToChilds": true,
        "Type": "bool",
        "SettingName": `${_group[x][0]._midleware.toUpperCase()}_${x.toUpperCase()}_TVGAMES_ACCESS`,
        "DefaultValue": "true",
        "Category": "PROVIDERS",
        "SettingsID": 1,
        "Value": true
      })
    })
    if(props.data.length > 0){
      debugger

    }
  }, []);

  useEffect(() => {
    setupdatedListKey(new Date().toJSON());
  }, [props?.permissions, games]);

  // props.data değiştiğinde data state'ini güncelle
  useEffect(() => {
    setData([...props.data]);
  }, [props.data]);

  const getProviderNames = () => {
    if (!games) return [];
    return Object.keys(games).filter(providerName => {
      // Önce arama filtresini kontrol et
      if (!providerName.toLowerCase()) {
        return false;
      }

      // Provider'ın oyunlarını kontrol et
      const providerGames = games[providerName];
      if (!providerGames || !Array.isArray(providerGames)) {
        return false;
      }

      // En az bir oyunun game_type = 1 olması gerekiyor
      return providerGames.some(game => game.game_type === 2);
    });
  };

  return (
    <Translation>
      {(t) => (
        <>
          <div
            style={{ overflow: "scroll", WebkitOverflowScrolling: "touch", paddingBottom: "calc(120px + env(safe-area-inset-bottom))" }}
            ref={containerRef}
            onScroll={handleScroll}
            className="pb-[20px] overflow-y-scroll"
            onLoad={adjustHeight}
            key={updatedListKey}
          >
            <PageBanner
              title={title}
              subTitle={t("SUBTITLE_BANNER_CASINO")}
              bg={pb}
            />

            <LiveProviderSwipeSelector
              selectedProviders={selectedProviders}
              setSelectedProviders={setSelectedProviders}
              setProvider={setProvider}
            />

            <section className="mb-1">
              <FilterTypes
                FilterSearchValue={FilterSearchValue}
                setFilterSearchValue={setFilterSearchValue}
                setProvider={setProvider}
                selectedProviders={selectedProviders}
                setSelectedProviders={setSelectedProviders}
                games={games}
                onFilterButtonsChange={setActiveFilterButton}
              />
            </section>


            {!isDirectLobby && (
              <section className="pb-4">
                <CategoryType
                  acitveMenu={acitveMenu}
                  setActiveMenu={(value) => {
                    if (value == "new") {
                      const new_data = props.data.sort(function (a, b) {
                        return b.id - a.id;
                      });
                      setData(new_data);
                      const _v = new_data.slice(0, 36);
                      setVisibleData(_v);
                    } else if (value == "hot") {
                      debugger
                      setData(props.data);
                      const _v = props.data.slice(0, 36);
                      setVisibleData(_v);
                    } else {
                      const new_data = props.data.filter((x) =>
                        x[x._midleware == 'matgame' ? 'name' : 'title'].toLowerCase().includes(value.toLowerCase())
                      );
                      setData(new_data);
                      const _v = new_data.slice(0, 36);
                      setVisibleData(_v);
                    }
                    setActiveMenu(value);
                  }}
                />
              </section>
            )}
            <div key={visibleData.length > 0 ? visibleData[0]._midleware : ''} className={`px-1 grid ${
              activeFilterButton === 2 
                ? 'grid-cols-3' 
                : 'grid-cols-2'
            } sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-7 2xl:grid-cols-8 gap-2 md:gap-4`}>
              {visibleData &&
                visibleData.map((item, index) => {
                  // MatGame oyunları için özel component
                  if (item._midleware == "matgame") {
                    if (item.is_active == 1) {
                      return (
                        <MatGameBox
                          key={item.id}
                          isLive={false}
                          index={index}
                          item={item}
                        />
                      );
                    } else {
                      debugger
                      return (<></>);
                    }
                  } else if (item._midleware == "innova") {
                    debugger
                    if (item.enabled == 1) {
                      return (
                        <InnovaBox
                          key={item.id}
                          isLive={false}
                          index={index}
                          item={item}
                        />
                      );
                    } else {
                      return (<></>);
                    }
                  }
                  else if (item._midleware == "gasea") {
                    return (
                      <GaseaBox
                        key={item.id}
                        isLive={false}
                        index={index}
                        item={item}
                        vendor={item._midleware}
                      />
                    );
                  }
                  else {
                    return (<></>);
                  }
                  // Diğer oyunlar için genel LiveGameBox kullan
                   
                })}
            </div>

            {/*isMobile || isTablet || isAndroid || true ? (
              <section className=" py-2 ">
                <ProvidersMobileSwiper
                  provider={provider}
                  _data={[
                    ...getProviderNames().map((providerName, index) => ({
                      name: "live/537.png",
                      //  name: `live/${providerName}.png`,
                      value: providerName,
                    })),
                    ...[
                      ...GameProviders.filter((x) => {
                        if (
                          x.value == "WorldMatch" &&
                          !props?.permissions?.WM?.Value
                        ) {
                          return false;
                        } else if (
                          x.value == "pragmatic-casino" &&
                          !props?.permissions?.PRAGMATIC_CASINO_ACCESS?.Value
                        ) {
                          return false;
                        } else if (
                          x.value == "amatic" &&
                          !props?.permissions?.AMATIC_CASINO_ACCESS?.Value
                        ) {
                          return false;
                        } else if (
                          x.value == "novomatic" &&
                          !props?.permissions?.NOVOMATIC_CASINO_ACCESS?.Value
                        ) {
                          return false;
                        } else if (
                          x.value == "bomba" &&
                          !props?.permissions?.BOMBA_CASINO_ACCESS?.Value
                        ) {
                          return false;
                        } else if (
                          x.value == "egt" &&
                          !props?.permissions?.EGT_CASINO_ACCESS?.Value
                        ) {
                          return false;
                        } else if (
                          x.value == "netent" &&
                          !props?.permissions?.NETENT_CASINO_ACCESS?.Value
                        ) {
                          return false;
                        } else if (
                          x.value == "yggdrasil" &&
                          !props?.permissions?.YGGDRASIL_CASINO_ACCESS?.Value
                        ) {
                          return false;
                        } else if (
                          x.value == "playngo" &&
                          !props?.permissions?.PLAYNGO_CASINO_ACCESS?.Value
                        ) {
                          return false;
                        } else if (
                          x.value == "aristocrat" &&
                          !props?.permissions?.ARISTOCRAT_CASINO_ACCESS?.Value
                        ) {
                          return false;
                        } else if (
                          x.value == "redtiger" &&
                          !props?.permissions?.REDTIGER_CASINO_ACCESS?.Value
                        ) {
                          return false;
                        } else if (
                          x.value == "playtech" &&
                          !props?.permissions?.PLAYTECH_CASINO_ACCESS?.Value
                        ) {
                          return false;
                        } else if (
                          x.value == "1X2_GAMING" &&
                          !props?.permissions?.X12_GAMING_CASINO_ACCESS?.Value
                        ) {
                          return false;
                        } else if (
                          x.value == "EVOPLAY" &&
                          !props?.permissions?.EVOPLAY_CASINO_ACCESS?.Value
                        ) {
                          return false;
                        } else if (
                          x.value == "IGT" &&
                          !props?.permissions?.IGT_CASINO_ACCESS?.Value
                        ) {
                          return false;
                        } else if (
                          x.value == "PLAYSON" &&
                          !props?.permissions?.PLAYSON_CASINO_ACCESS?.Value
                        ) {
                          return false;
                        } else if (
                          x.value == "BOOONGO" &&
                          !props?.permissions?.BOOONGO_CASINO_ACCESS?.Value
                        ) {
                          return false;
                        } else if (
                          x.value == "WAZDAN" &&
                          !props?.permissions?.WAZDAN_CASINO_ACCESS?.Value
                        ) {
                          return false;
                        } else if (
                          x.value == "RUBYPLAY" &&
                          !props?.permissions?.RUBYPLAY_CASINO_ACCESS?.Value
                        ) {
                          return false;
                        } else if (
                          x.value == "MICROGAMING" &&
                          !props?.permissions?.MICROGAMING_CASINO_ACCESS?.Value
                        ) {
                          return false;
                        } else if (
                          x.value == "BETSOFT" &&
                          !props?.permissions?.BETSOFT_CASINO_ACCESS?.Value
                        ) {
                          return false;
                        } else if (
                          x.value == "OCTAVIAN" &&
                          !props?.permissions?.OCTAVIAN_CASINO_ACCESS?.Value
                        ) {
                          return false;
                        } else if (
                          x.value == "SCIENTIFIC_GAMES" &&
                          !props?.permissions?.SCIENTIFIC_GAMES_CASINO_ACCESS
                            ?.Value
                        ) {
                          return false;
                        } else return true;
                      }),
                    ].filter((x) => games && games.hasOwnProperty(x.value)),
                  ]}
                />
              </section>
            ) : (
              <section className=" mobile-hide hidden"
              // key={updatedListKey}
               >
                <ProvidersSwiper
                  provider={provider}
                  _data={[
                    {
                      name: "live/537.png",
                      value: "537",
                    },
                    {
                      name: "live/668.png",
                      value: "668",
                    },
                    {
                      name: "live/480.png",
                      value: "480",
                    },
                    {
                      name: "live/19.png",
                      value: "19",
                    },
                    ...[
                      ...GameProviders.filter((x) => {
                        if (
                          x.value == "WorldMatch" &&
                          !props?.permissions?.WM?.Value
                        ) {
                          return false;
                        } else if (
                          x.value == "pragmatic-casino" &&
                          !props?.permissions?.PRAGMATIC_CASINO_ACCESS?.Value
                        ) {
                          return false;
                        } else if (
                          x.value == "amatic" &&
                          !props?.permissions?.AMATIC_CASINO_ACCESS?.Value
                        ) {
                          return false;
                        } else if (
                          x.value == "novomatic" &&
                          !props?.permissions?.NOVOMATIC_CASINO_ACCESS?.Value
                        ) {
                          return false;
                        } else if (
                          x.value == "bomba" &&
                          !props?.permissions?.BOMBA_CASINO_ACCESS?.Value
                        ) {
                          return false;
                        } else if (
                          x.value == "egt" &&
                          !props?.permissions?.EGT_CASINO_ACCESS?.Value
                        ) {
                          return false;
                        } else if (
                          x.value == "netent" &&
                          !props?.permissions?.NETENT_CASINO_ACCESS?.Value
                        ) {
                          return false;
                        } else if (
                          x.value == "yggdrasil" &&
                          !props?.permissions?.YGGDRASIL_CASINO_ACCESS?.Value
                        ) {
                          return false;
                        } else if (
                          x.value == "playngo" &&
                          !props?.permissions?.PLAYNGO_CASINO_ACCESS?.Value
                        ) {
                          return false;
                        } else if (
                          x.value == "aristocrat" &&
                          !props?.permissions?.ARISTOCRAT_CASINO_ACCESS?.Value
                        ) {
                          return false;
                        } else if (
                          x.value == "redtiger" &&
                          !props?.permissions?.REDTIGER_CASINO_ACCESS?.Value
                        ) {
                          return false;
                        } else if (
                          x.value == "playtech" &&
                          !props?.permissions?.PLAYTECH_CASINO_ACCESS?.Value
                        ) {
                          return false;
                        } else if (
                          x.value == "1X2_GAMING" &&
                          !props?.permissions?.X12_GAMING_CASINO_ACCESS?.Value
                        ) {
                          return false;
                        } else if (
                          x.value == "EVOPLAY" &&
                          !props?.permissions?.EVOPLAY_CASINO_ACCESS?.Value
                        ) {
                          return false;
                        } else if (
                          x.value == "IGT" &&
                          !props?.permissions?.IGT_CASINO_ACCESS?.Value
                        ) {
                          return false;
                        } else if (
                          x.value == "PLAYSON" &&
                          !props?.permissions?.PLAYSON_CASINO_ACCESS?.Value
                        ) {
                          return false;
                        } else if (
                          x.value == "BOOONGO" &&
                          !props?.permissions?.BOOONGO_CASINO_ACCESS?.Value
                        ) {
                          return false;
                        } else if (
                          x.value == "WAZDAN" &&
                          !props?.permissions?.WAZDAN_CASINO_ACCESS?.Value
                        ) {
                          return false;
                        } else if (
                          x.value == "RUBYPLAY" &&
                          !props?.permissions?.RUBYPLAY_CASINO_ACCESS?.Value
                        ) {
                          return false;
                        } else if (
                          x.value == "MICROGAMING" &&
                          !props?.permissions?.MICROGAMING_CASINO_ACCESS?.Value
                        ) {
                          return false;
                        } else if (
                          x.value == "BETSOFT" &&
                          !props?.permissions?.BETSOFT_CASINO_ACCESS?.Value
                        ) {
                          return false;
                        } else if (
                          x.value == "OCTAVIAN" &&
                          !props?.permissions?.OCTAVIAN_CASINO_ACCESS?.Value
                        ) {
                          return false;
                        } else if (
                          x.value == "SCIENTIFIC_GAMES" &&
                          !props?.permissions?.SCIENTIFIC_GAMES_CASINO_ACCESS
                            ?.Value
                        ) {
                          return false;
                        } else return true;
                      }),
                    ].filter((x) => games && games.hasOwnProperty(x.value)),
                  ]}
                />
              </section>
            )*/}

            {/*
            <section className="mb-1">
              <FilterTypes
                FilterSearchValue={FilterSearchValue}
                setFilterSearchValue={setFilterSearchValue}
              />
            </section>
            */}


            {(!data || data.length == 0) && <NoGamesFound title={title} showRefreshButton={false} />}

            <Footer />
          </div>
          {fabActive && (
            <button
              className=" btn bg-transparent nav-floating-btn text-white btn-circle fixed right-0 left-0 mx-auto bottom-20 shadow-xl fade-in"
              onClick={() => {
                const scl = containerRef.current;
                scl.scrollTo({
                  top: 0,
                  behavior: "smooth",
                });
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M4.5 10.5 12 3m0 0 7.5 7.5M12 3v18"
                />
              </svg>
            </button>
          )}
          {false && (
            <button
              className="btn btn-primary text-white btn-circle fixed right-5 bottom-20 shadow-xl fade-in"
              onClick={() => {
                const scl = containerRef.current;
                scl.scrollTo({
                  top: 0,
                  behavior: "smooth",
                });
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M4.5 10.5 12 3m0 0 7.5 7.5M12 3v18"
                />
              </svg>
            </button>
          )}

          <BottomNavigation
          //  permissions={props.permissions}
            isNavVisible={isNavVisible}
          />
        </>
      )}
    </Translation>
  );
};

const mapStateToProps = (state, props) => {
  const { authentication, game } = state;
  const { user, loggedIn, permissions } = authentication;
  const { sports, games } = game;
  return {
    user,
    loggedIn,
    sports,
    games,
    permissions,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    UpdateSport: (data) => dispatch(gameAction.UpdateSportsData(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ScrollableListView);

export const GetGamePoster = (cat, data) => {
  switch (cat) {
    case "pragmatic-casino":
      return `https://common-static.ppgames.net/game_pic/square/200/${data.gameID}.png`;
    case "smartsoft":
      return `https://maxbetone.s3.eu-central-1.amazonaws.com/images/smartsoft/${data.GameName}.png`.toLowerCase();
    default:
      break;
  }
};

const banners = [
  {
    id: 1,
    img: require('../../../assets/img/home/slots.png'),
    gradient: "from-blue-600 to-blue-800",
    path: "/casino"
  },
  {
    id: 2,
    img: require('../../../assets/img/home/livecasino.png'),

    gradient: "from-secondary-600 to-secondary-800",
    path: "/live-casino"
  },
  {
    id: 3,
    img: require('../../../assets/img/home/womensports.png'),

    gradient: "from-green-600 to-green-800",
    path: "/"
  },
  {
    id: 4,
    img: require('../../../assets/img/home/jackpot1.png'),

    gradient: "from-purple-600 to-purple-800",
    path: "/my-account/"
  }
];

export const GameProviders = [
  {
    name: "timeless/VivoGaming_Gold_Landscape.png",
    value: "vivo-timelesstech",
  },
  { name: "timeless/Ezugi_Logo_white.png", value: "ezugi-timelesstech" },
  {
    name: "timeless/evolution_logo_online_white_1000x194.png",
    value: "evolutionNHS-timelesstech",
  },
  {
    name: "timeless/evolution_logo_online_white_1000x194.png",
    value: "evolutionVHS-timelesstech",
  },
  {
    name: "timeless/ImaginLive_logo_bw.png",
    value: "imagine live-timelesstech",
  },
  { name: "timeless/PopOk_Vector_02.png", value: "popok-live-timelesstech" },
  { name: "timeless/tv_bet_final_logo_w.png", value: "tvbet-timelesstech" },
  {
    name: "timeless/onetouch_white_live.png",
    value: "onetouch-live-timelesstech",
  },

  {
    name: "timeless/SkyWindGroup_Logo2021.png",
    value: "skywind-live-timelesstech",
  },
  {
    name: "timeless/SkyWindGroup_Logo2021.png",
    value: "skywind-bj-timelesstech",
  },
  { name: "timeless/Absolute_logo_w_2.png", value: "absolute-timelesstech" },
  { name: "timeless/7mojos_logo.png", value: "7-mojos-timelesstech" },
  { name: "timeless/Religa_White.png", value: "religa-timelesstech" },
  {
    name: "timeless/evolution_logo_online_white_1000x194.png",
    value: "evolutionM-timelesstech",
  },
  {
    name: "timeless/evolution_logo_online_white_1000x194.png",
    value: "evolution-timelesstech",
  },
  {
    name: "timeless/evolution_logo_online_white_1000x194.png",
    value: "evolutionHS-timelesstech",
  },
  {
    name: "timeless/evolution_logo_online_white_1000x194.png",
    value: "evolutionRNG-timelesstech",
  },
  {
    name: "timeless/evolution_logo_online_white_1000x194.png",
    value: "evolutionX-timelesstech",
  },
  {
    name: "timeless/evolution_logo_online_white_1000x194.png",
    value: "evolutionBJ-timelesstech",
  },
  {
    name: "timeless/evolution_logo_online_white_1000x194.png",
    value: "evolutionZ-timelesstech",
  },
  {
    name: "timeless/evolution_logo_online_white_1000x194.png",
    value: "evolutionY-timelesstech",
  },
  {
    name: "timeless/evolution_logo_online_white_1000x194.png",
    value: "evolutionLS-timelesstech",
  },
  {
    name: "timeless/evolution_logo_online_white_1000x194.png",
    value: "evolutionXLS-timelesstech",
  },
  { name: "timeless/Ezugi_Logo_white.png", value: "ezugiX-timelesstech" },
  { name: "timeless/Ezugi_Logo_white.png", value: "ezugiZ-timelesstech" },
];

/*
  { name: "timeless/PP_Logo_On.png", value: "pragmatic-live-timelesstech" },
  { name: "timeless/PP_Logo_On.png", value: "pragmatic-bj-timelesstech" },

*/
/**
 
VİRTUAL E GEÇTİ TAMAMEN

 {
    name: "virtual.png",
    value: "VIRTUAL",
  },
    {
    name: "racing.png",
    value: "RACING",
  },

 */

/*
KALDIRILAN SAĞLAYICILAR

{
    {
    name: "merkur.svg",
    value: "merkur",
  },
   {
    name: "booming_games.png",
    value: "BOOMING_GAMES",
  },

    {
    name: "big_time_gaming.png",
    value: "BIG_TIME_GAMING",
  },
    {
    name: "leap.png",
    value: "LEAP",
  },
    name: "gaminator.png",
    value: "GAMINATOR",
  },
   {
    name: "platipus.png",
    value: "PLATIPUS",
  },
   {
    name: "merkur.png",
    value: "MERKUR",
  },
  {
    name: "red_rake.png",
    value: "RED_RAKE",
  },
  {
    name: "apex.png",
    value: "APEX",
  }
   {
    name: "quickspin.png",
    value: "QUICKSPIN",
  }, 
 
  {
    name: "ainsworth.png",
    value: "AINSWORTH",
  },
  {
    name: "firekirin.png",
    value: "FIREKIRIN",
  },
  {
    name: "apollo_games.png",
    value: "APOLLO_GAMES",
  },
  {
    name: "kajot.png",
    value: "KAJOT",
  },
  {
    name: "gameart.png",
    value: "GAMEART",
  },{
    name: "habanero.png",
    value: "HABANERO",
  },  {
    name: "isoftbet.png",
    value: "ISOFTBET",
  }, 
   {
    name: "skywind.png",
    value: "SKYWIND",
  },
    
   {
    name: "spinomenal.png",
    value: "SPINOMENAL",
  },
 {
    name: "iron_dog.png",
    value: "IRON_DOG",
  },
 {
    name: "igrosoft.png",
    value: "IGROSOFT",
  },*/

/*  {
    name: "xplosive.png",
    value: "XPLOSIVE",
  },
{
    name: "zeus_play.png",
    value: "ZEUS_PLAY",
  }
  */

/*
GAMES TARAFINA TRANSFER EDİLDİ

 {
    name: "super_keno.png",
    value: "SUPER_KENO",
  },
  {
    name: "spribe.png",
    value: "SPRIBE",
  },

*/
